var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.9999C10.3259 14.3325 10.7148 14.5967 11.1441 14.7771C11.5734 14.9575 12.0344 15.0504 12.5 15.0504C12.9656 15.0504 13.4266 14.9575 13.8559 14.7771C14.2852 14.5967 14.6741 14.3325 15 13.9999L19 9.99989C19.663 9.33685 20.0355 8.43757 20.0355 7.49989C20.0355 6.56221 19.663 5.66293 19 4.99989C18.337 4.33685 17.4377 3.96436 16.5 3.96436C15.5623 3.96436 14.663 4.33685 14 4.99989L13.5 5.49989",
    stroke: "#212E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 9.99973C13.6745 9.66713 13.2855 9.4029 12.8563 9.22252C12.427 9.04213 11.966 8.94922 11.5004 8.94922C11.0347 8.94922 10.5738 9.04213 10.1445 9.22252C9.71523 9.4029 9.32626 9.66713 9.00038 9.99973L5.00038 13.9997C4.33734 14.6628 3.96484 15.562 3.96484 16.4997C3.96484 17.4374 4.33734 18.3367 5.00038 18.9997C5.66342 19.6628 6.5627 20.0353 7.50038 20.0353C8.43806 20.0353 9.33734 19.6628 10.0004 18.9997L10.5004 18.4997",
    stroke: "#212E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachmentIcon.42fe51321e8a57a3ea1e2c4270b7619b.svg";
export { ForwardRef as ReactComponent };